<template>
  <sidebar-right @overlayClicked="outside" :class="[
    'navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--720',
    { open: show }
  ]">
    <div class="bg-white md__card--holder clearfix" v-if="tasks && step == 1">
      <div>
        <!-- Card header -->
        <div class="card-header d-flex align-items-center" :class="{
          'blue-class': $route.name == 'projects',
          'green-class': $route.name == 'tasks.home',
          'yellow-class': $route.name == 'timesheet.home'
        }">
          <!-- Title -->
          <!-- <div class="col px-0">
          <h4 class="h3 mb-0">{{project.name}}</h4>
            <h5 v-if="currentProject && currentProject.payment_status!='SUCCESS'">Payment Status: <span  style="color:red" class="error" >({{ currentProject.payment_status.replace("_"," ")  }})</span></h5>
            <span  style="color:red" class="error" v-if="currentProject && currentProject.financePayer && currentProject.payment_status != 'SUCCESS'">{{(currentProject.financePayer.user.id == profile.id)?"You are":currentProject.financePayer.user.first_name + ' is'}}  the Finance Administrator of this project.</span>
        </div> -->
          <h4 class="h3 mb-0 mt-1">
            Approve Tasks <span class="right-bracket position-relative d-inline-block" style="top:-2px">{</span>
          </h4>
        </div>

        <div class="card-header">
          <!-- <h3>Terms & Conditions </h3> -->
          <p>
            I,
            <strong>{{ profile.first_name }} {{ profile.last_name }}</strong>
            <strong v-if="profile.company && profile.company.name">of {{ profile.company && profile.company.name
            }}</strong> agree
            to approve <strong>{{ tasks.length }} Task(s)</strong> for total sum of
            <strong>{{ grandTotal.currency }}{{ grandTotal.netTotal }} </strong> paid as:

          </p>

          <strong>Fixed Fees:</strong>
          <table v-if="tasks && tasks.length > 0" class="table align-items-center table-light mt-2">

            <tbody class="list">
              <tr>

                <td class="px-3">
                  <span><strong>{{ fixedFee.currency }}{{ fixedFee.totalSumFormatted }}</strong> 
                    for <strong>{{ fixedFee.totalTasks }} Task(s)</strong>
                    </span>
                </td>
              </tr>

            </tbody>
          </table>


          <strong>Monthly Fees:</strong>
          <table v-if="tasks && tasks.length > 0" class="table align-items-center table-light mt-2">

            <tbody class="list">
              <!-- <tr v-for="(t, index) in paymentSummary.payNowTasks" :key="index">

                <td class="px-3">
                  <span><strong>{{ t.currency }}{{ t.payNowSumFormatted }}</strong> 
                    for <strong>{{ t.totalPayNowtasks }} Tasks</strong> Paid Now, 
                    </span>
                </td>
              </tr> -->

              <tr v-for="(t, index) in paymentSummary.rows" :key="index">

                <td class="px-3">
                  <span v-if="index == 0"><strong>{{ t.currency }}{{ t.monthlySum }}</strong> per month
                    for <strong>{{ t.months }}</strong> Months <strong>({{ t.currency }}{{ t.cost }})</strong>
                    </span>

                    <span v-if="index>0"><strong>Then {{ t.currency }}{{ t.monthlySum }}</strong> per month
                    for <strong>{{ t.months }}</strong> Months <strong>({{ t.currency }}{{ t.cost }})</strong>
                    </span>
                </td>
              </tr>

            </tbody>
          </table>

          <strong>Platform Fees:</strong>
          <table v-if="tasks && tasks.length > 0" class="table align-items-center table-light mt-2">

            <tbody class="list">
              
              <tr>
                <td class="px-3">
                  <span>Bracket Processing Fee <strong>{{ currentPayAmountBracketFee.currency }}{{ currentPayAmountBracketFee.bracketFeeFormatted }}
                    </strong>(2%) </span>
                </td>
              </tr>

             

            </tbody>
          </table>

          <strong>Taxes:</strong>
          <table v-if="tasks && tasks.length > 0" class="table align-items-center table-light mt-2">

            <tbody class="list">
              
              <tr>
                <td class="px-3">
                  <span>GST <strong> {{ grandTotal.currency }}{{ grandTotal.gstFormatted }}
                    </strong>(10%) </span>
                </td>
              </tr>

             

            </tbody>
          </table>


          <base-checkbox v-model="agreed" class="mt-1">
          </base-checkbox>
          Digitally Signed <a href="#">Terms and Conditions</a>
        </div>


      </div>

      <div class="row">
        <div class="col-md-6 p-4">
          <button class="btn  btn-success btn-block" @click="_onAcceptClicked">
            <span class="icon-sml">
              <i class="fas fa-pay"></i>
              Approve
            </span>
          </button>
        </div>

        <div class="col-md-6 p-4">
          <button class="btn  btn-danger btn-block" @click="$emit('onReject')">
            <span class="icon-sml">
              <i class="fas fa-pay"></i>
              Cancel
            </span>
          </button>
        </div>
      </div>


    </div>

    <div class="tab-content borderRadius-3" v-if="step==2">
        <!-- Card header -->
        <div class="card-header d-flex align-items-center" :class="{
          'blue-class': $route.name == 'projects',
          'green-class': $route.name == 'tasks.home',
          'yellow-class': $route.name == 'timesheet.home'
        }">
          <!-- Title -->
          <!-- <div class="col px-0">
          <h4 class="h3 mb-0">{{project.name}}</h4>
            <h5 v-if="currentProject && currentProject.payment_status!='SUCCESS'">Payment Status: <span  style="color:red" class="error" >({{ currentProject.payment_status.replace("_"," ")  }})</span></h5>
            <span  style="color:red" class="error" v-if="currentProject && currentProject.financePayer && currentProject.payment_status != 'SUCCESS'">{{(currentProject.financePayer.user.id == profile.id)?"You are":currentProject.financePayer.user.first_name + ' is'}}  the Finance Administrator of this project.</span>
        </div> -->
          <h4 class="h3 mb-0 mt-1">
            Approve Tasks <span class="right-bracket position-relative d-inline-block" style="top:-2px">{</span>
          </h4>
        </div>
      
      <div class="card-body d-flex justify-content-between align-items-center mb-2">
        <label>Select Payment Method</label>
        <div class="d-flex justify-content-end mb-2">
          <base-button :type="paymentMode=='card'?'primary':'outline'"  @click="paymentMode='card'">Credit Card</base-button>
          <base-button :type="paymentMode=='bank'?'primary':'outline'"  @click="paymentMode='bank'">Bank Transfer</base-button>
        </div>
      </div>
      <div id="payBills" role="tabpanel" class="col-sm-12 tab-pane fade active show">

        <h4 class="card-title mb-3">
            Total Amount {{ this.profile && this.profile.currency.symbol
            }}{{ currentPayAmountAdvance.netAmountFormatted }} 
          </h4>

        <div class="card card-body" v-if="paymentMode == 'bank'">
          <div class="row">
            <div class="col-sm-6 form-group">
              <label>Account Name</label>
              <h4 class="card-title">{{ this.paymentInfo.eftInfo.account_name}}</h4>
            </div>

            <div class="col-sm-6 form-group">
              <label>Account Number</label>
              <h4 class="card-title">{{ this.paymentInfo.eftInfo.account_number}}</h4>

             
            </div>

            <div class="col-sm-6 form-group">
              <label>BSB</label>
              <h4 class="card-title">{{ this.paymentInfo.eftInfo.bsb_number}}</h4>
            </div>

            <div class="col-sm-6 form-group">
              <label>Reference</label>
              <h4 class="card-title">{{ this.paymentInfo.eftInfo.reference}}</h4>
            </div>
          </div>
        </div>

      

        <div class="card card-body" v-if="paymentInfo.billingDetails && paymentMode == 'card'">
          
          <div class="row">
            <div class="col-sm-8">
              <label>Current Card</label>
              <h2>{{ paymentInfo.billingDetails.cc_number }}</h2>
            </div>
            <div class="col-sm-4 d-flex flex-row justify-content-center align-items-center">
              <button class="btn btn-sm" :class="{
                'btn-success': !editMode,
                'btn-danger': editMode
              }" @click="editMode = !editMode">
                <span class="icon-sml" v-if="!editMode">
                  <i class="fas fa-edit"></i>
                  Use Another Card
                </span>
                <span class="icon-sml" v-if="editMode">
                  <i class="fas fa-edit"></i>
                  Use Old Card
                </span>
              </button>
            </div>
          </div>
        </div>

        <div class="card card-body" v-if="
                            (paymentMode == 'card' && paymentInfo.billingDetails == null) ||
          (paymentMode == 'card' && editMode)">
          <!-- <h3 class="mb-2">Card Details </h3> -->
          <div class="row" v-if="
                            (paymentMode == 'card' && paymentInfo.billingDetails == null) ||
          (paymentMode == 'card' && editMode)">
            <div class="col-sm-6 form-group">
              <label>Card Holder Name</label>
              <input v-model="form.rebillCC.name" type="text" class="form-control" placeholder="Enter Full Name" />

              <span v-if="
                $v.form.rebillCC && $v.form.rebillCC.name && $v.form.rebillCC.name.$error
              " class="error field">
                Name is required
              </span>
            </div>

            <div class="col-sm-6 form-group">
              <label>Card Number</label>
              <input v-model="form.rebillCC.number" type="card" class="form-control" name="card"
                placeholder="Enter credit card no..." />
              <span v-if="
                $v.form.rebillCC && $v.form.rebillCC.number &&
                  $v.form.rebillCC.number.$error
              " class="error field">
                Card number is required
              </span>
            </div>

            <div class="col-sm-6 form-group">
              <label>CVC</label>
              <input v-model="form.rebillCC.cvc" type="number" class="form-control" name="cvc" placeholder="" />
              <span v-if="$v.form.rebillCC && $v.form.rebillCC.cvc && $v.form.rebillCC.cvc.$error" class="error field">
                required
              </span>
            </div>

            <div class="col-sm-6 form-group">
              <label>Expiry</label>
              <div class="d-flex">
                <input v-model="form.rebillCC.exp_month" type="text" class="form-control col-md-6 mr-1"
                  placeholder="MM" />
                <input v-model="form.rebillCC.exp_year" type="text" class="form-control col-md-6" placeholder="YY" />
              </div>
              <span v-if="
                ($v.form.rebillCC && $v.form.rebillCC.exp_year &&
                  $v.form.rebillCC.exp_year.$error) ||
                  ($v.form.rebillCC.exp_month &&
                    $v.form.rebillCC.exp_month.$error)
              " class="error field">
                required
              </span>
            </div>

            <div class="col-sm-12 d-flex flex-row justify-content-end">
             

              <base-checkbox v-model="form.saveCard" class="mt-1"></base-checkbox>
              <span class="ml-2">
                Save Card details for future
              </span>
            </div>
          </div>

          <hr />
          <!-- <h3 class="mb-2">Billing Details </h3> -->
          <div class="row" v-if="
            (paymentMode == 'card' &&
              paymentInfo.billingDetails == null) ||
              editMode
          ">
            <div class="col-sm-6 form-group">
              <label>First Name</label>
              <input v-model="form.customer.first_name" type="text" class="form-control"
                placeholder="Enter First Name" />
              <span v-if="
                $v.form.customer.first_name &&
                  $v.form.customer.first_name.$error
              " class="error field">
                First Name is required
              </span>
            </div>

            <div class="col-sm-6 form-group">
              <label>Last Name</label>
              <input v-model="form.customer.last_name" type="text" class="form-control" placeholder="Last Name" />
              <span v-if="
                $v.form.customer.last_name &&
                  $v.form.customer.last_name.$error
              " class="error field">
                Last Name is required
              </span>
            </div>

            <div class="col-sm-6 form-group">
              <label>Email</label>
              <input v-model="form.customer.email" type="text" class="form-control" placeholder="Enter Full Name" />

              <span v-if="
                $v.form.customer.email && $v.form.customer.email.$error
              " class="error field">
                Email is required
              </span>
            </div>

            <div class="col-sm-6 form-group">
              <label>Street</label>
              <input v-model="form.customer.address_street" type="text" class="form-control"
                placeholder="Enter Full Name" />
            </div>

            <div class="col-sm-6 form-group">
              <label>City</label>
              <input v-model="form.customer.suburb" type="text" class="form-control" placeholder="Enter City" />
            </div>

            <div class="col-sm-6 form-group">
              <label>Zip</label>
              <input v-model="form.customer.zip" type="text" class="form-control" placeholder="Enter Zip" />
            </div>

            <div class="col-sm-6 form-group">
              <label>State</label>
              <input v-model="form.customer.state" type="text" class="form-control" placeholder="Enter State" />
            </div>

            <div class="col-sm-6 form-group">
              <label>Country</label>

              <el-select v-model="form.customer.country" class="select-danger w-100" placeholder="Select Country"
                value-key="code">
                <el-option v-for="option in [
                  { name: 'Australia', code: 'AU' },
                  { name: 'United States', code: 'US' },
                  { name: 'United Kingdom', code: 'GB' },
                  { name: 'Nepal', code: 'NP' }
                ]" :value="option" :label="option.name" :key="option.code" class="select-danger" />
              </el-select>
            </div>
          </div>
        </div>


      </div>

      <div class="row">
        <div class="col-md-6 p-4">
          <button class="btn  btn-success btn-block" @click="_onPayNowClicked">
            <span class="icon-sml">
              <i class="fas fa-pay"></i>
              Pay Now
            </span>
          </button>
        </div>

        <div class="col-md-6 p-4">
          <button class="btn  btn-danger btn-block" @click="step=1">
            <span class="icon-sml">
              <i class="fas fa-pay"></i>
              Cancel
            </span>
          </button>
        </div>
      </div>
    </div>
  </sidebar-right>
</template>

<script>
import swal from "sweetalert2";
import { VueAvatar } from "vue-avatar-editor-improved";
import "sweetalert2/dist/sweetalert2.css";
import { mapState, mapActions, mapMutations } from "vuex";
import Modal from "@/components/Modal";
import AssignCompany from "@/app/components/AssignCompany.vue";
import axios from "axios";
import UserPicker from "@/app/components/UserPicker.vue";
import SidebarRight from "../layout/SidebarRight.vue";
import { required, minLength, between, email } from "vuelidate/lib/validators";
import numeral from 'numeral'
import moment from 'moment'
const groupByKey = (list, key) => list.reduce((hash, obj) => ({...hash, [obj[key]]:( hash[obj[key]] || [] ).concat(obj)}), {})

export default {
  name: "Acceptance",
  props: ["show", "fullWidth", "project", "budget"],
  components: {
    VueAvatar,
    AssignCompany,
    UserPicker,
    SidebarRight
  },

  data() {
    return {
      agreed: false,
      tasks: null,
      step:1,
      form: {
        customer: {},
        rebillCC: {}
      },
      bankForm: {},
      showCurrency: true,
      paymentMode: "card",
      paymentInfo: {},
      editMode: false, //later will use profile.hasCard
      payNowPercent: 100,
      gstPercent: 10,
      bracketFeePercent: 2,

      selects: {
        showCurrency: "",
        currency: [
          { value: "USD", label: "United states", symbol: "$" },
          { value: "AUD", label: "Australia", symbol: "$" },
          { value: "EUR", label: "Euro", symbol: "€" },
          { value: "GBP", label: "Pound Sterling", symbol: "£" },
          { value: "CAD", label: "Canada", symbol: "$" }
        ]
      },
    };
  },

  validations: {
    form: {
      customer: {
        first_name: {
          required
        }
      },
      rebillCC: {
        name: {
          required
        },
        number: {
          required
        },
        cvc: {
          required
        },
        exp_month: {
          required
        },
        exp_year: {
          required
        }
      }
    }
  },


  computed: {
    ...mapState("user", ["profile", "banners"]),
     
    ...mapState("common", ["countries"]),

    paymentSummary() {
      let sortedTasks = this.tasks.sort((a, b)=> parseInt(a.mbs_months) - parseInt(b.mbs_months))
      let months = sortedTasks.map(t => t.mbs_months).filter((item, i, ar) => ar.indexOf(item) === i && item>1);
      let rows=[]
     
      let count = 1
      let monthFactor = 0
      
      months.forEach(m => {
        let sum = 0
        let mSum = 0
        let thisMonth = m - monthFactor
        let tsks = []
        sortedTasks.filter(t => t.mbs_months >= m && t.mbs_months != 1).map(t => {
          let cst = this.taskBudget(t).totalCostNumber
          let perMonth = cst/t.mbs_months
          mSum += perMonth
          tsks.push({id: t.id, name:t.name})
        })

        console.log("---------------------------")

        sum = mSum * thisMonth
        // let sumFormatted = sum.toFixed(2)
        
        // if(sum>1000) {
        //   sumFormatted = (sum/1000).toFixed(2)+"k"
        // }

        
        count++

        rows.push({
          currency: this.profile && this.profile.currency.symbol,
          cost: numeral(sum).format(),
          months: thisMonth,
          totalCostNumber: sum,
          monthlySum: numeral(mSum).format(),
          tasks: tsks
        })
        monthFactor += thisMonth
      })

      return {rows}
    },
    


    

    grandTotal() {
      let tc = 0;
      this.tasks.map(t => {
        tc += this.taskBudget(t).totalCostNumber
      })

      let grossTotal = tc

      let bracketFee = parseFloat((tc * 2 / 100).toFixed(2));

      

      let gst = tc * 10/100
      gst = gst

      tc +=bracketFee

      tc += gst


      // let tcFormatted = tc.toFixed(2)
      // if (tc >= 1000) {
      //   tcFormatted = (tc / 1000).toFixed(2) + "k"
      // }
      
      return {
        currency: this.profile && this.profile.currency.symbol,
        bracketFee: bracketFee,
        grossTotal: grossTotal,
        bracketFeeFormatted: numeral(bracketFee).format,
        cost: tc,
        netTotal: numeral(tc).format(),
        gst: gst,
        gstFormatted: numeral(gst).format()
      }
    },
    
    fixedFee() {
      let totalTasks = 0
      let totalSum = 0
      let tsks = this.tasks.filter(t => t.mbs_months == 1).map(t=>{

        totalSum += this.taskBudget(t).totalCostNumber
        return {id: t.id, name: t.name}
      })

      // let totalSumFormatted = totalSum.toFixed(2)
      // if(totalSum>1000) {
      //   totalSumFormatted = (totalSum/1000).toFixed(2)+"k"
      // }

      return {currency: this.profile && this.profile.currency.symbol, totalSum, totalSumFormatted: numeral(totalSum).format(), totalTasks: tsks.length,  tasks: tsks}
    },


    recurringAmounts () {
      let data = []
      let dt = moment()
      
      this.paymentSummary.rows.map(r => {
        for(let i=1; i<= r.months; i++) {
          let amt =  r.totalCostNumber/r.months
          data.push({paymentDate: dt.format(), amount: amt, gst:  amt * this.gstPercent/100, currency: this.profile && this.profile.currency, tasks: r.tasks})
          dt.add(1, 'month')
        }
          
      })

      return data
    },

    currentPayAmountAdvance() {
      let firstMonth=0
      let firstMonthTasks = []
      if(this.paymentSummary.rows.length > 0) {
         firstMonth = this.paymentSummary.rows[0].totalCostNumber/this.paymentSummary.rows[0].months
         firstMonthTasks = this.paymentSummary.rows[0].tasks
      }
      
      let advance = ((this.fixedFee.totalSum+firstMonth) * this.payNowPercent/100)
      // let advanceFormatted = advance.toFixed(2)
      // if(advance>1000) {
      //   advanceFormatted = (advance/1000).toFixed(2)+"k"
      let gst = advance*this.gstPercent/100
      // }

      let net = advance+gst+this.currentPayAmountBracketFee.bracketFee

      return {currency: this.profile && this.profile.currency.symbol, advance, advanceFormatted: numeral(advance).format(), gst: gst, gstFormatted: numeral(gst).format(), tasks:[...firstMonthTasks, ...this.fixedFee.tasks], netAmountFormatted: numeral(net).format()}
    },

    currentPayAmountGST() {
      console.log("=========== "+this.currentPayAmountAdvance.currency) 
      let gst = (this.currentPayAmountAdvance.advance * this.gstPercent/100)
      let gstFormatted = gst.toFixed(2)
      if(gst>1000) {
        gstFormatted = (gst/1000).toFixed(2)+"k"
      }
      return {currency: this.profile && this.profile.currency.symbol, gst, gstFormatted: this.currentPayAmountAdvance.advance}
    },

    currentPayAmountBracketFee() {
      let bracketFee = (this.grandTotal.grossTotal * this.bracketFeePercent/100)
      // let bracketFeeFormatted = bracketFee.toFixed(2)
      // if(bracketFee>1000) {
      //   bracketFeeFormatted = (bracketFee/1000).toFixed(2)+"k"
      // }
      return {currency: this.profile && this.profile.currency.symbol, bracketFee, bracketFeeFormatted: numeral(bracketFee).format()}
    }


    
  },

  watch: {
    show(newval, oldval) {
      if (newval != oldval) {
        const d = localStorage.getItem('approvalTasks', null)
        if (d) {
          this.tasks = JSON.parse(d)
        } else {
          this.tasks = []
        }
      }
    }
  },

  mounted() {
    numeral.defaultFormat('0,0');
    const d = localStorage.getItem('approvalTasks', null)
    if (d) {
      this.tasks = JSON.parse(d)
    } else {
      this.tasks = []
    }

    console.log("data recurring dates", this.recurringAmounts)
    this.$nextTick(async () => {
      await this.fetchPayment();

      this.form = {
        ...this.form,
        customer: { ...this.profile, image: null, user_preference: null }
      };

      if (this.currentProject) {
        this.userInvite = this.currentProject.financePayer;
      }
    });
  },

  methods: {
    ...mapActions("user", [
      "savePreference",
      "updateProfileInfo",
      "deleteBanner",
      "saveBanner",
      "fetchBanners"
    ]),
    ...mapActions("project", [
      "invitePayersToProject",
      "fetchPaymentInfo",
      "createPayement"
    ]),

    



    taskBudget(task) {
      let totalHours = 0;
      let totalCost = 0;
      let t = task || {};

      totalCost = parseFloat((t.hourly_cost || 0))
      totalHours = parseInt(t.quoted_hours || 0);
      let dp = isNaN(parseInt(t.discount_percentage))
        ? 0
        : parseInt(t.discount_percentage);

      dp = 0; //for now make 0 as no ui for this 

      const numOfDays = parseInt(t.no_of_days || 1);
      const teamSize = parseInt(t.total_team_members || 1);
      if (this.profile.quoteCalculationInterval == "HOUR") {
        totalCost = totalCost * (totalHours) * teamSize * parseInt(t.mbs_months || 1);
      } else {
        totalCost = totalCost * (numOfDays * 8) * teamSize * parseInt(t.mbs_months || 1);
      }
      totalCost = (totalCost - (totalCost * dp) / 100);
      let totalCostNumber = totalCost

      totalCost = totalCost.toFixed(2);
      if (totalCost >= 1000) {
        totalCost = (totalCost / 1000).toFixed(2) + "k";
      }

      return {
        currency: this.profile && this.profile.currency.symbol,
        cost: totalCost,
        hours: totalHours,
        months: task.mbs_months,
        totalCostNumber: totalCostNumber
      };
    },


    _onAcceptClicked() {
      if (this.agreed) {
        this.step++;
        
      } else {
        this.$snack.success("Please accept terms and conditions")
      }
    },

    async _onPayNowClicked() {
      if (this.editMode) {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return false;
        }

        try {
          const body = {
            fixedFee: {paymentDate: moment().format(), fee: this.fixedFee.totalSum, tasks: this.fixedFee.tasks, gst: this.fixedFee.totalSum * this.gstPercent/100},
            recurringAmounts: this.recurringAmounts,
            ...this.form,
            project: this.project,
            mode: this.paymentMode,
            bracketFee:  this.grandTotal.bracketFee,
            currentPayAmount: this.currentPayAmountAdvance      
          };
          console.log("Body", body)

          let res = await this.createPayement(body);
          this.$snack.success(res.message);
          this.fetchPayment();
          this.$emit("paymentSuccess");
        } catch (e) {
          console.log(e, "error occured")
          this.$snack.success(
            e.response.data.message || "Error creating payment"
          );
        }
      } else {
        try {
          const body = {
            fixedFee: {paymentDate: moment().format(), fee: this.fixedFee.totalSum, tasks: this.fixedFee.tasks, gst: this.fixedFee.totalSum * this.gstPercent/100},
            recurringAmounts: this.recurringAmounts,
            project: this.project,
            mode: this.paymentMode,
            bracketFee:  this.grandTotal.bracketFee,
            currentPayAmount: this.currentPayAmountAdvance  
          };
          let res = await this.createPayement(body);
          this.$snack.success(res.message);
          this.fetchPayment();
          this.$emit("paymentSuccess");
        } catch (e) {
          console.log(e, "error occured while paying");
          this.$snack.success(
            e.response.data.message || "Error creating payment"
          );
        }
      }
    },

    async fetchPayment() {
      try {
        let res = await this.fetchPaymentInfo(this.project.id);
        this.paymentInfo = res;
        this.editMode = !this.paymentInfo.billingDetails;
      } catch (e) {
        console.log("eeeeee", e);
        this.$snack.success(
          e.response.data.title || "Error fetching payment info"
        );
      }
    },

    outside() {
      localStorage.setItem('approvalTasks', null)
      this.$emit("outSideClicked");
    }
  }
};
</script>

<style lang="scss">
.el-input input.el-input__inner {
  border-radius: 5px;
}

h4 span.right-bracket {
  color: #fddf43;
}
</style>
